
import Component from '../../../assets/scripts/modules/component'
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event'

class InteractiveBodyComponent extends Component {
  init () {
    this.buttons = [...this.element.querySelectorAll('.interactive-body__hitarea, .interactive-body__shape')]
    this.regions = [...this.element.querySelectorAll('.interactive-body__content')]

    this.initButtons()
    this.buttonHandler(false, this.buttons.find(button => button.getAttribute('aria-controls') === 'hart--content') || this.buttons[0])
  }

  initButtons () {
    this.buttons.forEach(button => button.addEventListener('click', event => this.buttonHandler(event, button)))

    // Workaround for svg non-focusable elements
    this.buttons.forEach(button => {
      button.setAttribute('tabindex', 0)
      button.addEventListener('keydown', event => (event.keyCode === 13) && this.buttonHandler(event, button))
    })
  }

  buttonHandler (event, currentButton, forceClose = false) {
    const region = document.getElementById(currentButton.getAttribute('aria-controls'))

    if (!region) {
      return
    }

    if (forceClose && currentButton.getAttribute('aria-expanded') === 'true') {
      this.toggleRegion(currentButton, region, true)
    } else {
      if (event) {
        this.buttons.forEach(button => button.getAttribute('aria-expanded') === 'true' && this.buttonHandler(null, button, true))
      }

      this.toggleRegion(currentButton, region)
    }
  }

  toggleRegion (button, region, forceClose = false) {
    if (!region && !button) {
      return
    }

    region = region || document.getElementById(button.getAttribute('aria-controls'))
    button = button || document.querySelector(`[aria-controls="${region.id}"]`)

    if (!region || !button) {
      return
    }

    const focusableElements = [...region.querySelectorAll('a, button, input, select, textarea')]

    if (forceClose || button.getAttribute('aria-expanded') === 'true') {
      region.setAttribute('aria-hidden', true)
      button.setAttribute('aria-expanded', false)

      focusableElements.forEach(element => this.deactivateFocusableElement(element))
    } else {
      region.setAttribute('aria-hidden', false)
      button.setAttribute('aria-expanded', true)

      focusableElements.forEach(element => this.activateFocusableElement(element))
    }
  }

  deactivateFocusableElement (element) {
    const tabindex = element.getAttribute('tabindex')

    if (tabindex !== null) {
      element.setAttribute('data-tabindex', tabindex)
    }

    element.setAttribute('tabindex', -1)
  }

  activateFocusableElement (element) {
    const tabindex = element.getAttribute('data-tabindex')

    if (tabindex !== null) {
      element.setAttribute('tabindex', tabindex)
    } else {
      element.removeAttribute('tabindex')
    }

    element.removeAttribute('data-tabindex')
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.interactive-body')) {
    element.instance = element.instance || new InteractiveBodyComponent(element)
  }
})
